import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { IncludesSection } from '../components/IncludesSection';
import { ProcessSection } from '../components/ProcessSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { FAQSection } from '../components/FAQSection';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
import { PurchaseToast } from '../components/PurchaseToast';
interface SalesPageProps {
  showPurchaseToast?: boolean;
}
export function SalesPage({
  showPurchaseToast = false
}: SalesPageProps) {
  return <main className="min-h-screen bg-stone-50 font-sans selection:bg-emerald-200 selection:text-emerald-900" data-id="element-441">
      <Hero data-id="element-442" />
      <ProblemSection data-id="element-443" />
      <SolutionSection data-id="element-444" />
      <IncludesSection data-id="element-445" />
      <ProcessSection data-id="element-446" />
      <TestimonialsSection data-id="element-447" />
      <CTASection enableExitIntent={showPurchaseToast} data-id="element-448" />
      <FAQSection data-id="element-449" />
      <Footer data-id="element-450" />
      {showPurchaseToast && <PurchaseToast data-id="element-451" />}
    </main>;
}